module.exports = __webpack_public_path__ + "media/images/banks/rhb-abb67eb60d7ab93e3afeb2433aa4d46e.png";